import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=0e0064aa&scoped=true"
import script from "./LayoutSidebar.vue?vue&type=script&lang=ts"
export * from "./LayoutSidebar.vue?vue&type=script&lang=ts"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&id=0e0064aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0064aa",
  null
  
)

export default component.exports